import { render, staticRenderFns } from "./CTenant.vue?vue&type=template&id=5c3be0e0"
import script from "./CTenant.vue?vue&type=script&lang=js"
export * from "./CTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports